<template>
  <div v-if="campania" class="tarjeta-menu" data-test="tarjeta-menu">
    <div class="d-flex align-start tarjeta-menu-fila">
      <div class="tarjeta-menu-icono">
        <v-icon small color="white">mdi-storefront-outline</v-icon>
      </div>
      <div class="tarjeta-menu-cuerpo">
        <div class="tarjeta-menu-titulo">{{ campania.titulo }}</div>
        <div v-if="campania.texto" class="tarjeta-menu-texto">{{ campania.texto }}</div>
        <a class="tarjeta-menu-ver" data-test="tarjeta-ver" @click.prevent="ir">
          {{ campania.boton_texto || "Ver más" }} →
        </a>
      </div>
      <v-btn icon x-small color="white" aria-label="Cerrar" data-test="tarjeta-cerrar" @click="cerrar">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { abrirEnlaceCampania } from "@/utils/publicidadEnlace";

/**
 * Tarjeta silenciosa al pie del menú lateral. Lee la campaña de tipo "menu" del
 * store y no renderiza nada si no hay. Va sobre el color del drawer, con una capa
 * oscura translúcida para no depender del tema de cada comercio.
 */
export default {
  name: "TarjetaMenu",
  computed: {
    campania() {
      const porTipo = this.$store.getters["publicidad/porTipo"] || {};
      return porTipo.menu || null;
    },
  },
  watch: {
    campania: {
      immediate: true,
      handler(campania, anterior) {
        if (campania && (!anterior || anterior.id !== campania.id)) {
          this.$store.dispatch("publicidad/verVista", campania.id);
        }
      },
    },
  },
  methods: {
    ir() {
      this.$store.dispatch("publicidad/clic", this.campania.id);
      abrirEnlaceCampania(this.campania.boton_url);
    },
    cerrar() {
      this.$store.dispatch("publicidad/cerrar", this.campania.id);
    },
  },
};
</script>

<style scoped>
.tarjeta-menu {
  margin: 8px 12px 12px;
  padding: 12px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.18);
  color: #ffffff;
}
.tarjeta-menu-fila {
  gap: 10px;
}
.tarjeta-menu-icono {
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
}
.tarjeta-menu-cuerpo {
  flex: 1 1 auto;
  min-width: 0;
}
.tarjeta-menu-titulo {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
}
.tarjeta-menu-texto {
  font-size: 12px;
  line-height: 1.35;
  opacity: 0.85;
  margin-top: 2px;
}
.tarjeta-menu-ver {
  display: inline-block;
  margin-top: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
  text-decoration: none;
  cursor: pointer;
}
.tarjeta-menu-ver:hover {
  text-decoration: underline;
}
</style>
